export const fonts = {
  heading: 'Nunito',
  body: 'Nunito',
};
